var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5980_7144",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99523 1.09829C8.99839 1.06595 9 1.03316 9 1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1C7 1.03319 7.00162 1.066 7.00478 1.09836C4.65185 1.56974 2.87279 3.67925 2.87279 6.20376C2.87279 7.76507 2.26425 9.26723 1.17498 10.3727L0.905397 10.6463C0.523889 11.0009 0.318359 11.504 0.318359 12.0368C0.318359 13.1181 1.18731 14 2.2527 14L6 14C6 15.1046 6.89543 16 8 16C9.10457 16 10 15.1046 10 14L13.7477 14C14.813 14 15.682 13.1181 15.682 12.0368C15.682 11.504 15.4765 11.0008 15.095 10.6463L14.8254 10.3727C13.7361 9.26723 13.1276 7.76507 13.1276 6.20376C13.1276 3.67912 11.3483 1.56953 8.99523 1.09829ZM1.61771 11.3482L1.88729 11.0746C3.16368 9.77918 3.87279 8.02375 3.87279 6.20376C3.87279 3.87198 5.7384 2 8.00018 2C10.262 2 12.1276 3.87198 12.1276 6.20376C12.1276 8.02375 12.8367 9.77918 14.1131 11.0746L14.3826 11.3482C14.3929 11.3586 14.4035 11.3689 14.4142 11.3788C14.5768 11.5299 14.682 11.7603 14.682 12.0368C14.682 12.5798 14.2469 13 13.7477 13H2.2527C1.75349 13 1.31836 12.5798 1.31836 12.0368C1.31836 11.7603 1.42355 11.5299 1.58613 11.3789C1.59688 11.3689 1.60741 11.3586 1.61771 11.3482ZM8 15C7.44772 15 7 14.5523 7 14H9C9 14.5523 8.55228 15 8 15Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5980_7144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOutlined);
export default __webpack_public_path__ + "static/media/bell-outlined.9b2d6ebb087adf9caf79066f74850e4f.svg";
export { ForwardRef as ReactComponent };